import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import getLocale from '../../i18n/getLocale';

// Tabs
import FlightReportRefuelRequestEditTab from './Elements/FlightReportRefuelRequestEditTab';

class FlightReportRefuelsRequestEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      flight_report_refuel_request_edit: {},
      flight_report_refuels: [],
      flight_reports_select: [],
      flight_report_legs_select: [],
      fuel_suppliers_select: [],
      refuel_reasons_select: [],
      aircrafts_select: [],
      helitank_select: [],
      locations_select: [],
      companies_select: [],
      staff_select: [],
      bases_select: [],
      flight_report_legs: [],
      fuel_types_select: [],
      fuel_unity: '',
      user: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();

    this.updateData = this.updateData.bind(this);
    this.loadData = this.loadData.bind(this);
    this.deleteRefuel = this.deleteRefuel.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  updateData (responseJson) {
    this.setState({updated: 1, show_select: 0}, this.loadData(responseJson));
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/solicitacao/abastecimento/'+ self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/solicitacoes/abastecimentos');
        if (responseJson.status === 'success') {
          self.setState({
            flight_report_refuel_request_edit: responseJson.data.main,
            flight_report_refuels: responseJson.data.main.flight_report_refuels,
            flight_reports_select: responseJson.data.flight_reports_select,
            flight_report_legs: responseJson.data.flight_report_legs_select,
            fuel_suppliers_select: responseJson.data.fuel_suppliers_select,
            refuel_reasons_select: responseJson.data.refuel_reasons_select,
            aircrafts_select: responseJson.data.aircrafts_select,
            helitank_select: responseJson.data.helitank_select,
            locations_select: responseJson.data.locations_select,
            companies_select: responseJson.data.companies_select,
            staff_select: responseJson.data.staff_select,
            fuel_types_select: responseJson.data.fuel_types_select,
            bases_select: responseJson.data.bases_select,
            fuel_unity: responseJson.data.fuel_unity,
            user: responseJson.data.user,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */
    });
  }

  deleteRefuel (id, index) {
    if (id !== null && typeof id !== 'undefined') {
      var confirm = window.confirm('Are you sure you want to delete this record?');
      if (confirm) {
        this.handleAlert('', '', 'open');
        var datasave = {
          id: id,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/relatorio/voo/abastecimento', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(id, index);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    } else {
      this.deleteRow(null, index);
    }
  }

  deleteRow (id, index) {
    var data = this.state.flight_report_refuels;
    data.map(function(row, position) {
      if (id !== null && typeof id !== 'undefined' && row.id == id) {
        data.splice(position, 1);
      } else if (position == index) {
        data.splice(position, 1);
      }
    });
    this.setState({data: data});
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
        <h3 className="page-title pull-left">{this.locale.RelatorioAbastecimento.EditarAbastecimento.tituloSolicitacao}</h3>
        <div className="grid-buttons pull-right">
          <Link to="/abastecimentos/solicitacoes" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
        </div>
        <div className="clearfix"></div>
        <hr/>
        <FlightReportRefuelRequestEditTab updateData={this.updateData} updated={this.state.updated} handleAlert={this.handleAlert} flight_report_refuel_request_edit={this.state.flight_report_refuel_request_edit} flight_report_refuels={this.state.flight_report_refuels} flight_reports_select={this.state.flight_reports_select} flight_report_legs={this.state.flight_report_legs} flight_report_legs_select={this.state.flight_report_legs_select} fuel_suppliers_select={this.state.fuel_suppliers_select} refuel_reasons_select={this.state.refuel_reasons_select} aircrafts_select={this.state.aircrafts_select} locations_select={this.state.locations_select} companies_select={this.state.companies_select} staff_select={this.state.staff_select} fuel_types_select={this.state.fuel_types_select} bases_select={this.state.bases_select} deleteRefuel={this.deleteRefuel} fuel_unity={this.state.fuel_unity} user={this.state.user} helitank_select={this.state.helitank_select} />
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportRefuelsRequestEdit;



// WEBPACK FOOTER //
// ./src/Components/FlightReportRefuels/FlightReportRefuelsRequestEdit.js